<template>
  <div id="app">
  </div>
</template>
<script>
    export default {
        components: {
        },
        data(){
            return{
            }
        },
        vuex: {
            getters: {

            },
            actions: {

            }
        },
        methods: {
        },
        computed:{
        },
        watch:{
        },
        created(){
            window.location.href = '/login.html';
        },
    }
</script>